import { render, staticRenderFns } from "./PurchasesScreen.vue?vue&type=template&id=3f1db70c&scoped=true&"
import script from "./PurchasesScreen.vue?vue&type=script&lang=js&"
export * from "./PurchasesScreen.vue?vue&type=script&lang=js&"
import style0 from "./PurchasesScreen.vue?vue&type=style&index=0&id=3f1db70c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f1db70c",
  null
  
)

export default component.exports